<template>
  <div id="scheduleDetail_localData">
    <NOT_DATA
      :className="'relativePtb30'"
      v-if="localDataProp && !localDataProp.isHasData"
    />
    <template v-else>
      <EVENTCOP_MODE_1
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_1' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
      ></EVENTCOP_MODE_1>

      <EVENTCOP_MODE_2
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_2' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
      ></EVENTCOP_MODE_2>

      <EVENTCOP_MODE_3
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_3' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="localDataProp.type"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_3>

      <EVENTCOP_MODE_6
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_6' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_6>

      <EVENTCOP_MODE_8
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_8' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_8>

      <EVENTCOP_MODE_9
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_9' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_9>

      <EVENTCOP_MODE_10
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_10' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="localDataProp.type"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_10>

      <EVENTCOP_MODE_12
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_12' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="localDataProp.type"
      ></EVENTCOP_MODE_12>

      <EVENTCOP_MODE_13
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_13' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="localDataProp.type"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_13>

      <EVENTCOP_MODE_17
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_17' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="localDataProp.type"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_17>

      <EVENTCOP_MODE_19
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_19' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="localDataProp.type"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_19>

      <EVENTCOP_MODE_20
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_20' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="localDataProp.type"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_20>

      <EVENTCOP_MODE_21
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_21' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="localDataProp.type"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_21>

      <EVENTCOP_MODE_22
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_22' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="localDataProp.type"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_22>

      <EVENTCOP_MODE_24
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_24' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="localDataProp.type"
        :competitorType="localDataProp.competitorType"
        :isCombatFlag="localDataProp.isCombatFlag"
      ></EVENTCOP_MODE_24>

      <EVENTCOP_MODE_26
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'mode_26' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="localDataProp.type"
        :competitorType="localDataProp.competitorType"
      ></EVENTCOP_MODE_26>

      <template
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'complexTypeMode_6_7_5'
        "
      >
        <!-- 小节比分 -->
        <EVENTCOP_MODE_6
          v-if="eventCompModeDatas"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
          :competitorType="localDataProp.competitorType"
        ></EVENTCOP_MODE_6>

        <!-- 球队对比 -->
        <EVENTCOP_MODE_7
          v-if="eventCompModeDatas"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
          :competitorType="localDataProp.competitorType"
        ></EVENTCOP_MODE_7>

        <!-- 球队统计 -->
        <EVENTCOP_MODE_5
          v-if="eventCompModeDatas"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
        ></EVENTCOP_MODE_5>
      </template>

      <template
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'complexTypeMode_6_7_25'
        "
      >
        <!-- 小节比分 -->
        <EVENTCOP_MODE_6
          v-if="eventCompModeDatas"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
          :competitorType="localDataProp.competitorType"
        ></EVENTCOP_MODE_6>

        <!-- 球队对比 -->
        <EVENTCOP_MODE_7
          v-if="eventCompModeDatas && eventCompModeDatas.competitorStats"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
          :competitorType="localDataProp.competitorType"
        ></EVENTCOP_MODE_7>

        <!-- 球队统计 -->
        <EVENTCOP_MODE_25
          v-if="eventCompModeDatas && eventCompModeDatas.athleteStats"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
        ></EVENTCOP_MODE_25>
      </template>

      <template
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'complexTypeMode_17_17'
        "
      >
        <template v-for="indexNo in [0, 1]">
          <EVENTCOP_MODE_17
            :key="indexNo"
            v-if="eventCompModeDatas"
            :currThemeObj="currThemeObj"
            :currCid="currCid"
            :currSid="currSid"
            :sportsTypeArr="sportsTypeArr"
            :currSportsDetail="currSportsDetail"
            :datas="eventCompModeDatas"
            :tabType="localDataProp.type"
            :competitorType="localDataProp.competitorType"
            :indexNo="indexNo"
          ></EVENTCOP_MODE_17>
        </template>
      </template>

      <template
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'complexTypeMode_6_19'
        "
      >
        <EVENTCOP_MODE_6
          v-if="eventCompModeDatas"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
          :competitorType="localDataProp.competitorType"
        ></EVENTCOP_MODE_6>

        <EVENTCOP_MODE_19
          v-if="eventCompModeDatas"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
          :tabType="localDataProp.type"
          :competitorType="localDataProp.competitorType"
        ></EVENTCOP_MODE_19>
      </template>

      <template
        v-if="
          localDataProp &&
          localDataProp.eventCompMode === 'complexTypeMode_19_19'
        "
      >
        <template v-for="indexNo in [0, 1]">
          <EVENTCOP_MODE_19
            :key="indexNo"
            v-if="eventCompModeDatas"
            :currThemeObj="currThemeObj"
            :currCid="currCid"
            :currSid="currSid"
            :sportsTypeArr="sportsTypeArr"
            :currSportsDetail="currSportsDetail"
            :datas="eventCompModeDatas"
            :tabType="localDataProp.type"
            :competitorType="localDataProp.competitorType"
            :indexNo="indexNo + 1"
          ></EVENTCOP_MODE_19>
        </template>
      </template>

      <template
        v-if="
          localDataProp && localDataProp.eventCompMode === 'complexTypeMode_6_8'
        "
      >
        <EVENTCOP_MODE_6
          v-if="eventCompModeDatas"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
          :competitorType="localDataProp.competitorType"
        ></EVENTCOP_MODE_6>

        <EVENTCOP_MODE_8
          v-if="eventCompModeDatas"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
          :tabType="localDataProp.type"
          :competitorType="localDataProp.competitorType"
        ></EVENTCOP_MODE_8>
      </template>

      <!-- 以前的水球 -->
      <!-- <template
        v-if="
          localDataProp && localDataProp.eventCompMode === 'complexTypeMode_6_5'
        "
      >
        <EVENTCOP_MODE_6
          v-if="eventCompModeDatas"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
        ></EVENTCOP_MODE_6>

        <EVENTCOP_MODE_5
          v-if="eventCompModeDatas"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
        ></EVENTCOP_MODE_5>
      </template> -->

      <div
        class="note_box"
        v-show="
          eventCompModeDatas.annotation &&
          eventCompModeDatas.annotation.length > 0
        "
      >
        <span class="note_title" v-text="'注释'"></span>
        <span class="note_info">
          <span
            class="noteInfo_item"
            v-for="(item, index) in eventCompModeDatas.annotation"
            :key="index"
            v-text="`${item.name}：${item.explain}`"
          ></span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import NOT_DATA from '@components/base/NO_DATA.vue'
import EVENTCOP_MODE_1 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_1.vue'
import EVENTCOP_MODE_2 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_2.vue'
import EVENTCOP_MODE_3 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_3.vue'
import EVENTCOP_MODE_5 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_5.vue'
import EVENTCOP_MODE_6 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_6.vue'
import EVENTCOP_MODE_7 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_7.vue'
import EVENTCOP_MODE_8 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_8.vue'
import EVENTCOP_MODE_9 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_9.vue'
import EVENTCOP_MODE_10 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_10.vue'
import EVENTCOP_MODE_12 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_12.vue'
import EVENTCOP_MODE_13 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_13.vue'
import EVENTCOP_MODE_17 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_17.vue'
import EVENTCOP_MODE_19 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_19.vue'
import EVENTCOP_MODE_20 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_20.vue'
import EVENTCOP_MODE_21 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_21.vue'
import EVENTCOP_MODE_22 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_22.vue'
import EVENTCOP_MODE_24 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_24.vue'
import EVENTCOP_MODE_25 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_25.vue'
import EVENTCOP_MODE_26 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_26.vue'
export default {
  name: 'scheduleDetail_localData',
  mixins: [cup_base_data_mixin],
  components: {
    NOT_DATA,
    EVENTCOP_MODE_1,
    EVENTCOP_MODE_2,
    EVENTCOP_MODE_3,
    EVENTCOP_MODE_5,
    EVENTCOP_MODE_6,
    EVENTCOP_MODE_7,
    EVENTCOP_MODE_8,
    EVENTCOP_MODE_9,
    EVENTCOP_MODE_10,
    EVENTCOP_MODE_12,
    EVENTCOP_MODE_13,
    EVENTCOP_MODE_17,
    EVENTCOP_MODE_19,
    EVENTCOP_MODE_20,
    EVENTCOP_MODE_21,
    EVENTCOP_MODE_22,
    EVENTCOP_MODE_24,
    EVENTCOP_MODE_25,
    EVENTCOP_MODE_26,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    scheduleDetailDatas: {
      type: Object,
      default: () => ({}),
    },
    localDataProp: {
      type: Object,
      default: () => ({
        datas: null, //初始化时为null, 一旦赋值过只能为正常数据||{}
        isHasData: true,
        eventCompMode: '', //mode_1
        type: '',
        competitorType: '',
        isCombatFlag: false, //对抗|非对抗
        groupIndexStr: '-1',
      }),
    },
  },
  watch: {
    localDataProp: {
      handler(newVal, oldVal) {
        console.debug('localData 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          if (
            newVal.eventCompMode === 'complexTypeMode_6_7_5' &&
            newVal.datas &&
            newVal.datas.athleteStats &&
            newVal.datas.athleteStats.annotation
          ) {
            let datas = newVal.datas
            datas.annotation = newVal.datas.athleteStats.annotation
            this.eventCompModeDatas = JSON.parse(
              JSON.stringify(datas ? datas : {})
            )
          } else {
            this.eventCompModeDatas = JSON.parse(
              JSON.stringify(newVal.datas ? newVal.datas : {})
            )
          }
        }
        console.debug('this.eventCompModeDatas:', this.eventCompModeDatas)
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      // eventCompMode: 'mode_2',
      competitorType: null,
      eventCompModeDatas: null,
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   // window.scrollTo(0, Math.floor(30.776 * this.vw2px))
    //   window.scrollTo(0, Math.floor((12.36+0.694) * this.vw2px))
    // })
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
#scheduleDetail_localData {
  padding-bottom: 2.083vw;
  .note_box {
    width: 100%;
    padding: 0.694vw 1.338vw 4.16vw;
    /* border-top: 1px solid var(--mixtmt_greyColor8); */
    .note_title {
      display: block;
      font-size: 1.11vw;
      color: var(--mixtmt_mainColor);
      line-height: 2.083vw;
      font-weight: bold;
    }
    .note_info {
      width: 100%;
      padding: 0 0.694vw 0 0;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .noteInfo_item {
        width: auto;
        min-width: 12.5%;
        text-align: left;
        font-size: 1.11vw;
        line-height: 2.5vw;
        color: var(--mixtmt_greyColor2);
        padding-left: 1.388vw;
        &:first-child {
          padding-left: 0.694vw;
        }
      }
    }
  }
}
</style>
